import React from 'react'
import { useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { Text } from 'src/components/atoms'

export default function SectionHeader() {
  const {
    reports: {
      reportsResources: { R10Data }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  if (R10Data.loading) {
    return
  }

  const requestsCount = new Set(
    R10Data.data.map(record => record.request_number)
  ).size
  const receiptsCount = R10Data.data.length

  return (
    <>
      <div>
        <Text strong suffix=": " text="web.report.10.header.text1" />
        <Text>{`${receiptsCount}`}</Text>
      </div>
      <div>
        <Text strong suffix=": " text="web.report.10.header.text2" />
        <Text>{`${requestsCount}`}</Text>
      </div>
    </>
  )
}
